// extracted by mini-css-extract-plugin
export default {"buttons":"styles__buttons___U+2k2"};